import React from 'react';

interface SectionLayoutProps {
  title: string;
  children?: React.ReactNode;
}

export function SectionLayout({ title, children }: SectionLayoutProps) {
  return (
    <div className="p-6 space-y-6">
      <h1 className="h1">{title}</h1>
      {children}
    </div>
  );
} 